var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99992 2.66667C1.26354 2.66667 0.666585 2.06971 0.666585 1.33333C0.666585 0.596954 1.26354 -9.047e-08 1.99992 -5.82818e-08C2.7363 -2.60937e-08 3.33325 0.596954 3.33325 1.33333C3.33325 2.06971 2.7363 2.66667 1.99992 2.66667ZM1.99992 7.33333C1.26354 7.33333 0.666585 6.73638 0.666585 6C0.666585 5.26362 1.26354 4.66667 1.99992 4.66667C2.7363 4.66667 3.33325 5.26362 3.33325 6C3.33325 6.73638 2.7363 7.33333 1.99992 7.33333ZM0.666585 10.6667C0.666585 11.403 1.26354 12 1.99992 12C2.7363 12 3.33325 11.403 3.33325 10.6667C3.33325 9.93029 2.7363 9.33333 1.99992 9.33333C1.26354 9.33333 0.666585 9.93029 0.666585 10.6667Z",
    fill: "#4D596B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMore);
export default __webpack_public_path__ + "static/media/show-more.7199c65e900e287653cf235983d5f6dc.svg";
export { ForwardRef as ReactComponent };